import React from 'react';
import { Chip, ChipProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import PendingIcon from '@mui/icons-material/Pending';
import WarningIcon from '@mui/icons-material/Warning';

export type StatusType = 'active' | 'inactive' | 'pending' | 'warning' | 'success' | 'error' | 'info';

interface StatusBadgeProps extends Omit<ChipProps, 'color'> {
  status: StatusType;
  label?: string;
  showIcon?: boolean;
  small?: boolean;
  color?: string;
  icon?: React.ReactElement | undefined;
}

const statusConfig = {
  active: {
    color: 'success',
    icon: CheckCircleIcon,
    defaultLabel: 'Actif',
  },
  inactive: {
    color: 'default',
    icon: CancelIcon,
    defaultLabel: 'Inactif',
  },
  pending: {
    color: 'warning',
    icon: PendingIcon,
    defaultLabel: 'En attente',
  },
  warning: {
    color: 'warning',
    icon: WarningIcon,
    defaultLabel: 'Attention',
  },
  success: {
    color: 'success',
    icon: CheckCircleIcon,
    defaultLabel: 'Succès',
  },
  error: {
    color: 'error',
    icon: CancelIcon,
    defaultLabel: 'Erreur',
  },
  info: {
    color: 'info',
    icon: PendingIcon,
    defaultLabel: 'Info',
  },
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  label,
  icon,
  showIcon = true,
  small = false,
  color = '',
  ...props
}) => {
  const theme = useTheme();
  const config = statusConfig[status];
  const Icon = config.icon;


  return (
    <Chip
      label={label || config.defaultLabel}
      color={color || config.color as any}
      icon={showIcon ? <Icon /> : undefined}
      size={small ? 'small' : 'medium'}
      sx={{
        fontWeight: 500,
        ...props.sx,
      }}
      {...props}
    />
  );
};
